import { create } from "zustand";
import { Task } from "../Pages/Tasks_new/types";

type ModalStore = {
  open: boolean | "boost" | "dailyReward" | string;
  closing: boolean;
  currentTask?: Task | null;
  source?: string;
  setClosing: (arg: boolean) => void;
  setOpen: (
    arg: boolean | "boost" | "dailyReward" | string,
    source?: string
  ) => void;
  setCurrentTask: (task: Task | null) => void;
  handleClose: () => void;
};

export const useModalStore = create<ModalStore>((set) => ({
  open: false,
  closing: false,
  currentTask: null,
  source: undefined,
  setOpen: (arg, source) => set({ open: arg, closing: false, source }),
  setClosing: (arg) => set({ closing: arg }),
  setCurrentTask: (task) => set({ currentTask: task }),
  handleClose: () => {
    set({ closing: true });
    setTimeout(() => {
      set({ closing: false, open: false, source: undefined });
    }, 300);
  },
}));
